import styled from 'styled-components';

const GridRowBase = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const GridHeaderRow = styled(GridRowBase)`
  padding: 6px 24px;
  background-color: var(--color-bg-tertiary);
  border-width: 1px 0px;
  border-style: solid;
  border-color: var(--color-grey-8);
`;
const GridRow = styled(GridRowBase)`
  padding: 14px 24px;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.08) inset;
  &:hover {
    background-color: var(--color-bg-hover);
  }
  &:hover a {
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-thickness: 0.5px;
    text-decoration-color: var(--color-status-info);
  }
`;
const Col = styled.div`
  flex: 1;
`;

const GlobalSearchStyles = {
  GridHeaderRow,
  GridRow,
  Col,
};

export default GlobalSearchStyles;
